import videojs from 'video.js';
import vjsSrv from '../services/vjsSrv';
import eventsSrv from '../services/events';
import { PLAYER_EVENTS } from 'vimmi-web-utils/cjs/postMessage';
import { PMWrap } from '../services/PMWrap';
import Config from 'src/js/services/config';

export class CutVideoService {
  constructor() {
    this.options = {
      start_time: 0,
      duration: 30,
      max_duration: 30,
      min_duration: 2,
    };
  }

  enable(options) {
    this.options = Object.assign(this.options, options);
    this.options.disabled = false;
    vjsSrv.vjsPlayer.addClass('cut-video-enabled');
    let button = this.getControlBar()
      .getChild('CutVideoButton');
    if (!button) {
      this.getControlBar()
        .addChild('CutStartTimeInput');
      this.getControlBar()
        .addChild('CutEndTimeInput');
      button = this.getControlBar()
        .addChild('CutVideoButton');

      this.getSeekBar()
        .addClass('custom-seek-bar');
      this.getSeekBar()
        .addChild('StartCutButton');
      this.getSeekBar()
        .addChild('EndCutButton');
      vjsSrv.vjsPlayer
        .on('timeupdate', () => {
          if (!this.options.disabled) {
            if (vjsSrv.vjsPlayer.currentTime() > (this.options.start_time + this.options.duration) ||
              vjsSrv.vjsPlayer.currentTime() < (this.options.start_time)) {
              vjsSrv.vjsPlayer.currentTime(this.options.start_time);
            }
          }
        });
    } else {
      button.enable();
      this.getStartButton()
        .show();
      this.getEndButton()
        .show();
      this.getStartButton()
        .enable();
      this.getEndButton()
        .enable();

      this.getEndTimeInput()
        .show();
      this.getStartTimeInput()
        .show();
    }
  }

  disable() {

    vjsSrv.vjsPlayer.removeClass('cut-video-enabled');
    this.options.disabled = true;
    this.getStartButton()
      .hide();
    this.getEndButton()
      .hide();
    this.getStartButton()
      .disable();
    this.getEndButton()
      .disable();

    this.getEndTimeInput()
      .hide();
    this.getStartTimeInput()
      .hide();

    this.getControlBar()
      .getChild('CutVideoButton')
      .disable();
  }

  get(key) {
    return this.options[key] !== undefined ? this.options[key] : null;
  }

  set(key, value) {
    this.options[key] = value;
  }

  getControlBar() {
    return vjsSrv.vjsPlayer
      .getChild('ControlBar');
  }

  getSeekBar() {
    return this.getControlBar()
      .getChild('ProgressControl')
      .getChild('SeekBar');
  }

  getEndButton() {
    return this.getSeekBar()
      .getChild('EndCutButton');
  }

  getStartButton() {
    return this.getSeekBar()
      .getChild('StartCutButton');
  }

  getStartTimeInput() {
    return this.getControlBar()
      .getChild('CutStartTimeInput');
  }

  getEndTimeInput() {
    return this.getControlBar()
      .getChild('CutEndTimeInput');
  }

  parseTimeString(string = '') {
    if (string.length) {
      if (string.indexOf(':') !== -1) {
        let chanks = string.split(':');
        let hh = '00';
        let mm = 0;
        let ss = 0;
        if (chanks.length === 3) {
          hh = chanks[0];
          mm = chanks[1];
          ss = chanks[2];
        } else if (chanks.length === 2) {
          mm = chanks[0];
          ss = chanks[1];
        } else {
          return false;
        }
        if (hh.length > 2) {
          hh = hh.slice(0, 2);
        }
        if (mm.length > 2) {
          mm = mm.slice(0, 2);
        }
        if (ss.length > 2) {
          ss = ss.slice(0, 2);
        }

        if (!isNaN(parseInt(hh)) && !isNaN(parseInt(mm)) && !isNaN(parseInt(ss))) {
          hh = parseInt(hh) * 60 * 60;
          mm = parseInt(mm) * 60;
          ss = parseInt(ss);

          return hh + mm + ss;
        }
        return null;

      } else {
        return parseInt(string);
      }
    }
    return null;
  }

  formatSeconds(seconds) {
    seconds = parseInt(seconds);
    if (!isNaN(parseInt(seconds))) {
      let hh = Math.floor(seconds / 60 / 24);
      let mm = Math.floor((seconds - (hh * 60 * 24)) / 60);
      let ss = Math.floor(seconds - ((hh * 60 * 24) + (mm * 60)));
      return (hh < 10 ? '0' + hh : hh) + ':' + (mm < 10 ? '0' + mm : mm) + ':' + (ss < 10 ? '0' + ss : ss);
    }
    return null;
  }
}

let Button = videojs.getComponent('Button');
let Component = videojs.getComponent('Component');
let ClickableComponent = videojs.getComponent('ClickableComponent');

let CutVideoButton = videojs.extend(Button, {
  constructor: function() {
    Button.apply(this, arguments);
    this.addClass('vjs-cut-video-btn');
    this.controlText('Cut selected part');
  },
  handleClick: function() {
    let SeekBar = this.player()
      .getChild('controlBar')
      .getChild('ProgressControl')
      .getChild('SeekBar');

    let startBut = SeekBar.getChild('StartCutButton');
    let endBut = SeekBar.getChild('EndCutButton');

    let startTime = parseFloat(startBut._startTime.toFixed(2));
    let endTime = parseFloat(endBut._endTime.toFixed(2));
    let duration = parseFloat((endTime - startTime).toFixed(2));

    if (duration > vjsSrv.vjsPlayer.get('max_duration') || duration < vjsSrv.vjsPlayer.get('min_duration')) {
      startBut.addClass('incorrect-time');
      endBut.addClass('incorrect-time');
      setTimeout(() => {
        startBut.removeClass('incorrect-time');
        endBut.removeClass('incorrect-time');
      }, 2000);
      return;
    }
    //      return ;
    let eventData = {
      start: startTime,
      end: endTime,
      duration: duration,
    };
    eventsSrv.emit(PLAYER_EVENTS.CUT_VIDEO_DATA, eventData);

    if (!Config.get('params.imported')) {
      PMWrap.inst().sendWrappedEvent(PLAYER_EVENTS.CUT_VIDEO_DATA, eventData);
    }
  },
});
let CutStartTimeInput = videojs.extend(Component, {
  constructor: function() {
    Component.apply(this, arguments);
  },
  setTime: function(value) {

    this._input.value = vjsSrv.vjsPlayer.CutVideoSrv.formatSeconds(value) || '';
  },
  createEl: function createEl() {
    let wrapper = videojs.dom.createEl('div', {
      className: 'vjs-control vjs-cut-video-input-time',
    }, {
      title: 'Please put here start time in format: HH:mm:ss or mm:ss or just seconds',
    });
    let input = videojs.dom.createEl('input', {
      className: 'start-time-inp',
    }, {
      placeholder: 'Start time',
    });
    this._input = input;
    input.addEventListener('change', () => {
      this.player()
        .currentTime(vjsSrv.vjsPlayer.CutVideoSrv.getStartButton()._startTime);
    });
    input.addEventListener('input', () => {
      let time = vjsSrv.vjsPlayer.CutVideoSrv.parseTimeString(input.value);
      if (time === null) {
        return;
      }

      let videoDuration = this.player()
        .duration();
      if (time > videoDuration || time < 0) {
        this.addClass('incorrect-time');
      } else {
        this.removeClass('incorrect-time');
      }

      if (time < 0) {
        time = 0;
      } else if (time > this.player()
        .duration() || time + vjsSrv.vjsPlayer.CutVideoSrv.get('min_duration') > this.player()
        .duration()) {
        time = this.player()
          .duration() - vjsSrv.vjsPlayer.CutVideoSrv.get('min_duration');
        vjsSrv.vjsPlayer.CutVideoSrv.set('duration', vjsSrv.vjsPlayer.CutVideoSrv.get('min_duration'));
      } else if (time + vjsSrv.vjsPlayer.CutVideoSrv.get('duration') > this.player()
        .duration()) {
        vjsSrv.vjsPlayer.CutVideoSrv.set('duration', this.player()
          .duration() - time);
      } else if (time + vjsSrv.vjsPlayer.CutVideoSrv.get('duration') < this.player()
        .duration()) {
        vjsSrv.vjsPlayer.CutVideoSrv.set('duration', vjsSrv.vjsPlayer.CutVideoSrv.get('max_duration'));
      }

      vjsSrv.vjsPlayer.CutVideoSrv.getEndButton()
        .moveToSec(time + vjsSrv.vjsPlayer.CutVideoSrv.get('duration'));
      vjsSrv.vjsPlayer.CutVideoSrv.getStartButton()
        .moveToSec(time);
      vjsSrv.vjsPlayer.CutVideoSrv.getEndTimeInput()
        .setTime(time + vjsSrv.vjsPlayer.CutVideoSrv.get('duration'));

    });
    wrapper.appendChild(input);

    return wrapper;
  },
});
let CutEndTimeInput = videojs.extend(Component, {
  constructor: function() {
    Component.apply(this, arguments);
  },
  setTime: function(value) {
    this._input.value = vjsSrv.vjsPlayer.CutVideoSrv.formatSeconds(value) || '';
  },
  createEl: function createEl() {
    let wrapper = videojs.dom.createEl('div', {
      className: 'vjs-control vjs-cut-video-input-time',
    }, {
      title: 'Please put here end time in format: HH:mm:ss or mm:ss or just seconds',
    });
    let input = videojs.dom.createEl('input', {
      className: 'end-time-inp',
    }, {
      placeholder: 'End time',
    });
    this._input = input;
    input.addEventListener('change', () => {
      this.player()
        .currentTime(vjsSrv.vjsPlayer.CutVideoSrv.getStartButton()._startTime);
    });
    input.addEventListener('input', () => {
      let time = vjsSrv.vjsPlayer.CutVideoSrv.parseTimeString(input.value);
      if (time === null) {
        return;
      }
      let videoDuration = this.player()
        .duration();
      if (time > videoDuration || time < CutVideoSrv.get('min_duration')) {
        this.addClass('incorrect-time');
      } else {
        this.removeClass('incorrect-time');
      }

      if (time < vjsSrv.vjsPlayer.CutVideoSrv.get('min_duration')) {
        time = vjsSrv.vjsPlayer.CutVideoSrv.get('min_duration');
        vjsSrv.vjsPlayer.CutVideoSrv.set('duration', vjsSrv.vjsPlayer.CutVideoSrv.get('min_duration'));
      } else if (time < vjsSrv.vjsPlayer.CutVideoSrv.get('max_duration')) {
        vjsSrv.vjsPlayer.CutVideoSrv.set('duration', time);
      } else if (time > videoDuration) {
        time = videoDuration;
      } else if (time >= vjsSrv.vjsPlayer.CutVideoSrv.get('max_duration')) {
        vjsSrv.vjsPlayer.CutVideoSrv.set('duration', vjsSrv.vjsPlayer.CutVideoSrv.get('max_duration'));
      }

      vjsSrv.vjsPlayer.CutVideoSrv.getEndButton()
        .moveToSec(time);
      vjsSrv.vjsPlayer.CutVideoSrv.getStartButton()
        .moveToSec(time - vjsSrv.vjsPlayer.CutVideoSrv.get('duration'));

      vjsSrv.vjsPlayer.CutVideoSrv.getStartTimeInput()
        .setTime(time - vjsSrv.vjsPlayer.CutVideoSrv.get('duration'));

    });
    wrapper.appendChild(input);
    return wrapper;
  },
});

let StartCutButton = videojs.extend(ClickableComponent, {
  constructor: function() {
    ClickableComponent.apply(this, arguments);

    this.addClass('vjs-start-cut-position');
    this.controlText('Start position');
    this.addChild('TimeTooltip');

    this.on('mousedown', this._mouseDown);
    //      this.on('mousemove', this._mouseMove);
    //      this.on('mouseup', this._mouseUp);
    window.addEventListener('mousemove', (event) => {
      this._mouseMove(event);
    });
    window.addEventListener('mouseup', (event) => {
      this._mouseUp(event);
    });
    //      this.on('mouseleave', this._mouseLeave);
    this.player()
      .one('timeupdate', () => {
        this.moveToSec(vjsSrv.vjsPlayer.CutVideoSrv.get('start_time'), true);
      });
    this._isMouseDown = false;
  },
  _mouseDown: function(event) {
    this._isMouseDown = true;
    event.stopPropagation();
  },
  _mouseUp: function(event) {
    if (this._isMouseDown) {
      this.player()
        .userActive(true);
      this.player()
        .currentTime(this._startTime);
      event.stopPropagation();
    }
    this._isMouseDown = false;
  },
  _mouseMove: function(event) {
    if (this._isMouseDown) {
      let seekBar = vjsSrv.vjsPlayer.CutVideoSrv.getSeekBar();
      let seekBarPoint = videojs.dom.getPointerPosition(seekBar.el_, event).x;

      let newTime = seekBarPoint * this.player()
        .duration();
      if (newTime + vjsSrv.vjsPlayer.CutVideoSrv.get('duration') < this.player()
        .duration()) {
        this.moveToSec(newTime, true);
        vjsSrv.vjsPlayer.CutVideoSrv.getEndButton()
          .moveToSec(this._startTime + vjsSrv.vjsPlayer.CutVideoSrv.get('duration'), true);
      }
      event.stopPropagation();
    }
  },
  moveToSec: function(seconds, isSetInput) {
    let buttonRect = videojs.dom.getBoundingClientRect(this.el_);
    let seekBarRect = videojs.dom.getBoundingClientRect(vjsSrv.vjsPlayer.CutVideoSrv.getSeekBar()
      .el());
    let seekBarNewPoint = seconds / this.player()
      .duration();

    this.player()
      .userActive(true);
    this._startTime = seconds;
    this.el().style.left = ((seekBarRect.width * seekBarNewPoint) - buttonRect.width / 2) + 'px';
    this._updateToolTip(seekBarRect, seekBarNewPoint);
    if (isSetInput) {
      vjsSrv.vjsPlayer.CutVideoSrv.getStartTimeInput()
        .setTime(seconds);
    }

    vjsSrv.vjsPlayer.CutVideoSrv.set('start_time', seconds);
  },
  //    _mouseLeave: function(event) {

  //      this._isMouseDown = false;
  //      event.stopPropagation();
  //    },
  _updateToolTip: function(seekBarRect, seekBarPoint) {
    let duration = this.player()
      .duration();
    this.getChild('TimeTooltip')
      .update(seekBarRect, seekBarPoint, videojs.formatTime(seekBarPoint * duration, duration));
    //      this.getChild('TimeTooltip');
    //        .el().style.left = '0';
    //      this.getChild('TimeTooltip')
    //        .el().style.right = 'auto';
  },
});

let EndCutButton = videojs.extend(ClickableComponent, {
  constructor: function() {
    ClickableComponent.apply(this, arguments);

    this.addClass('vjs-end-cut-position');
    this.controlText('End position');
    this.addChild('TimeTooltip');
    this.on('mousedown', this._mouseDown);

    //      this.on('mousemove', this._mouseMove);
    //      this.on('mouseleave', this._mouseLeave);
    //      this.on('mouseup', this._mouseUp);

    window.addEventListener('mousemove', (event) => {
      this._mouseMove(event);
    });
    window.addEventListener('mouseup', (event) => {
      this._mouseUp(event);
    });

    this.player()
      .one('timeupdate', () => {
        this.moveToSec(vjsSrv.vjsPlayer.CutVideoSrv.get('start_time') + vjsSrv.vjsPlayer.CutVideoSrv.get('duration'), true);
      });
    this._isMouseDown = false;
  },
  _mouseDown: function(event) {
    this._isMouseDown = true;
    event.stopPropagation();
  },
  _mouseUp: function(event) {
    if (this._isMouseDown) {
      this.player()
        .userActive(true);
      this.player()
        .pause();
      this.player()
        .currentTime(this._endTime);
      event.stopPropagation();
    }
    this._isMouseDown = false;
  },
  //    _mouseLeave: function(event) {
  //
  //      this._isMouseDown = false;
  //      event.stopPropagation();
  //    },
  _mouseMove: function(event) {
    if (this._isMouseDown) {
      let seekBar = vjsSrv.vjsPlayer.CutVideoSrv.getSeekBar();

      //        let buttonRect = videojs.dom.getBoundingClientRect(this.el_);
      //        let seekBarRect = videojs.dom.getBoundingClientRect(seekBar.el());
      let seekBarPoint = videojs.dom.getPointerPosition(seekBar.el(), event).x;

      let newTime = seekBarPoint * this.player()
        .duration();
      if ((newTime - vjsSrv.vjsPlayer.CutVideoSrv.getStartButton()._startTime) >= vjsSrv.vjsPlayer.CutVideoSrv.get('min_duration')) {
        vjsSrv.vjsPlayer.CutVideoSrv.set('duration', newTime - vjsSrv.vjsPlayer.CutVideoSrv.getStartButton()._startTime);
        this.moveToSec(newTime, true);
        if ((newTime - vjsSrv.vjsPlayer.CutVideoSrv.getStartButton()._startTime) >= vjsSrv.vjsPlayer.CutVideoSrv.get('max_duration')) {
          vjsSrv.vjsPlayer.CutVideoSrv.getStartButton()
            .moveToSec(newTime - vjsSrv.vjsPlayer.CutVideoSrv.get('max_duration'), true);
        }
      }
      event.stopPropagation();
    }
  },
  moveToSec: function(seconds, isSetInput) {
    let buttonRect = videojs.dom.getBoundingClientRect(this.el_);
    let seekBarRect = videojs.dom.getBoundingClientRect(vjsSrv.vjsPlayer.CutVideoSrv.getSeekBar()
      .el());
    let seekBarNewPoint = seconds / this.player()
      .duration();

    this.player()
      .userActive(true);

    this._endTime = seconds;
    this.el().style.left = ((seekBarRect.width * seekBarNewPoint) - buttonRect.width / 2) + 'px';
    this._updateToolTip(seekBarRect, seekBarNewPoint);

    if (isSetInput) {
      vjsSrv.vjsPlayer.CutVideoSrv.getEndTimeInput()
        .setTime(seconds);
    }
  },
  _updateToolTip: function(seekBarRect, seekBarPoint) {
    let duration = this.player()
      .duration();
    this.getChild('TimeTooltip')
      .update(seekBarRect, seekBarPoint, videojs.formatTime(seekBarPoint * duration, duration));
    //      this.getChild('TimeTooltip')
    //        .el().style.left = '0';
    //      this.getChild('TimeTooltip')
    //        .el().style.right = 'auto';
  },
});

videojs.registerComponent('CutStartTimeInput', CutStartTimeInput);
videojs.registerComponent('CutEndTimeInput', CutEndTimeInput);
videojs.registerComponent('StartCutButton', StartCutButton);
videojs.registerComponent('EndCutButton', EndCutButton);
videojs.registerComponent('CutVideoButton', CutVideoButton);